import React, { useEffect, useMemo } from 'react';
import useForm from '~/app/modules/form/useForm';
import { IssueClosePayload } from '~/types';
import classes from './style.module.scss';
import MForm from '~/app/modules/form';
import Textarea from '~/app/modules/form/Textarea';
import useTranslation from '~/app/hooks/useTranslation';
import RadioCheckGroup from '~/app/modules/form/RadioCheckGroup';
import { IssueCloseTypes, useIssueCloseOptions } from '~/app/data/statuses/issue';
import WorkOrder from './WorkOrder';
import { useStoreActions, useStoreState } from '~/store';

export type DetailsComponent = React.FC;

const Details: DetailsComponent = () => {
  const { t } = useTranslation('issue');
  const { values: formValues, fieldEvents: formFieldEvents } = useForm<IssueClosePayload>({ formName: 'closeIssue' });

  const hasParts = useStoreState(state => (state.issue.data.parts?.length ?? 0) > 0);
  const setIsWorkOrderFormActive = useStoreActions(action => action.issue.setIsWorkOrderFormActive);
  const isWorkOrderFormActive = useStoreState(state => state.issue.isWorkOrderFormActive);
  const hasSimplifiedWorkorderEnabled = useStoreState(state => state.issue.data?.hasSimplifiedWorkorderEnabled ?? false);
  const issueDepartment = useStoreState(state => state.issue.data.issueDepartmentId);
  const user = useStoreState(state => state.user.data);

  const isSimplifiedWorkOrderEligible = useMemo(() => (
    user.is_active && (user?.departments ?? []).includes(Number(issueDepartment ?? '-1')) && !!hasSimplifiedWorkorderEnabled
  ), [hasSimplifiedWorkorderEnabled, issueDepartment, user.departments, user.is_active]);

  const options: { label: string, value: string }[] = useIssueCloseOptions(isSimplifiedWorkOrderEligible);

  useEffect(() => {
    setIsWorkOrderFormActive(isSimplifiedWorkOrderEligible && formValues.issueCloseType === IssueCloseTypes.CORRECTEDWORKORDER);
  }, [formValues.issueCloseType, isSimplifiedWorkOrderEligible, setIsWorkOrderFormActive]);

  return (
    <>
      <MForm className={`${classes['form']} ${classes['details']}`}>
        <div className={classes['issue-close']}>
          <RadioCheckGroup
            name="issueCloseType"
            options={options}
            onChange={formFieldEvents.onChange}
            inputClassName={classes['radio-check']}
          />
          <Textarea
            className={`${classes['input-container']}`}
            placeholder={t('issueClose.comment.placeholder')}
            descriptionPosition="top"
            name="comment"
            defaultValue={formValues.comment as string}
            {...formFieldEvents}
          />
          {!isWorkOrderFormActive && hasParts && <p className={classes['part-warning']}><b>{t('issueClose.warning')}</b>: {t('issueClose.partsWarning')}</p>}
        </div>
        {isWorkOrderFormActive && <WorkOrder />}
      </MForm>
    </>
  );
};

export default Details
